import axios from "@/axios"

const url = "/api/brain/tournament/beneficiaries"

class TournamentBeneficiariesService {
	async getBeneficiaries(params) {
		const { data } = await axios.get(`${url}`, {
			params,
		})
		return data
	}
	async toggleStatus(id) {
		await axios.put(`${url}/toggle-status/${id}`)
	}
	async store(body) {
		await axios.post(`${url}`, body)
	}
	async destroy(id) {
		await axios.delete(`${url}/${id}`)
	}
	async update(id, body) {
		await axios.put(`${url}/${id}`, body)
	}
	async getBanks() {
		const { data } = await axios.get(`${url}/banks`)
		return data
	}
	async assignTournament(body) {
		await axios.post(`${url}/assign-tournament`, body)
	}
	async tracking(id) {
		const { data } = await axios.get(`${url}/tracking/${id}`)
		return data
	}

}
export default new TournamentBeneficiariesService()
